export const defaultRejectReason = [
    {
        "id": "aefyuh",
        "text": "Invalid Document"
    },
    {
        "id": "dfgsdh",
        "text": "The Image is blurry"
    },
    {
        "id": "tyhgfd",
        "text": "The Document has expired"
    },
    {
        "id": "ghjklo",
        "text": "Name on Id different from name in profile"
    },
    {
        "id": "fghjas",
        "text": "Address in document different from Address in profile"
    },
]